import React, { FC } from 'react'

import Img, { GatsbyImageProps, GatsbyImageFluidProps, FixedObject, FluidObject } from 'gatsby-image'

interface GatsbyImageFluidPropsI {
  src: GatsbyImageProps | string
  objectFit?: string
  /**
   * @deprecated Use `fixed`
   */
  resolutions?: FixedObject
  /**
   * @deprecated Use `fluid`
   */
  sizes?: FluidObject
  fadeIn?: boolean
  durationFadeIn?: number
  title?: string
  alt?: string
  className?: string | Record<string, unknown>
  critical?: boolean
  crossOrigin?: string | boolean
  style?: Record<string, unknown>
  imgStyle?: Record<string, unknown>
  placeholderStyle?: Record<string, unknown>
  placeholderClassName?: string
  backgroundColor?: string | boolean
  onLoad?: () => void
  onError?: (event: unknown) => void
  onStartLoad?: (param: { wasCached: boolean }) => void
  Tag?: string
  itemProp?: string
  loading?: `auto` | `lazy` | `eager`
  draggable?: boolean
}
const GatsbyImageFluid: FC<GatsbyImageFluidPropsI> = ({ src, ...rest }) => {
  const isTypeFluid = (img: GatsbyImageProps): img is GatsbyImageFluidProps => {
    return (img as GatsbyImageFluidProps).fluid !== undefined
  }
  return (
    <React.Fragment>
      {typeof src !== 'string' && isTypeFluid(src) && <Img fluid={src.fluid} {...rest}></Img>}
    </React.Fragment>
  )
}

export default GatsbyImageFluid
